import {type Module} from 'vuex';
import calendar from './calendar';
import chat from './chat';
import customer from './customer';
import enrolment from './enrolment';
import gallery from './gallery';
import home from './home';
import installer from './installer';
import news from './news';
import page from './page';
import school from './school';
import services from './services';
import sessionservice from './sessionservice';
import shiftSchedule from './shiftSchedule';
import task from './task';

const module: Module<null, RootState> = {
    namespaced: true,
    modules: {
        home,
        chat,
        news,
        enrolment,
        gallery,
        page,
        task,
        school,
        calendar,
        services,
        shiftSchedule,
        sessionservice,
        installer,
        customer,
    },
};

export default module;